import { parseFormattedNumber } from './functions'

/*
	EmployeeStock.notes is now a NoteItem[] ({ key, value }), not a free-text string.
	An expense entry is one item where key = expense name and value = its amount. Other
	parts of the system may append NoteItem entries that don't fit this shape - those are
	kept verbatim as foreignItems so they're never lost when the array is rebuilt.
*/
export function parseExpenseEntries(notes) {
	if (!Array.isArray(notes)) return { entries: [], foreignItems: [] }

	const entries = []
	const foreignItems = []

	notes.forEach(item => {
		const amount = item ? parseFormattedNumber(item.value) : null

		if (!item || !item.key || amount === null) {
			foreignItems.push(item)
			return
		}

		entries.push({ id: entries.length + 1, name: item.key, amount })
	})

	return { entries, foreignItems }
}

export function buildExpenseNotes({ entries, foreignItems }) {
	return [
		...(foreignItems || []),
		...(entries || []).map(entry => ({ key: entry.name, value: String(entry.amount) }))
	]
}
